import { Documento, ISdocumento } from "../../processo/Documento";
import { ISusuarioList, UsuarioList } from "../../usuario/UsuarioList";

export interface DocumentoEmail {
    id: string;
    para: string;
    assunto: string;
    mensagem: string;    
    usuario: UsuarioList;
    dataHora: Date | null;
    documento: Documento;
}

export const ISdocumentoEmail: DocumentoEmail = {
    id: "",
    para: "",
    assunto: "",
    mensagem: "",
    usuario: ISusuarioList,
    dataHora: null,
    documento: ISdocumento,
}
